export default "__VITE_ASSET__CgoH3EK6__"